"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.template = template;
const AirPage = __importStar(require("./air-page"));
const CoeffIntervalPage = __importStar(require("./coeff-interval-page"));
const GeometryPage = __importStar(require("./geometry-page"));
const VelocityPage = __importStar(require("./velocity-page"));
function template(coilType, si) {
    const doc = [
        {
            name: "Geometry",
            data: GeometryPage.geometryPage(coilType, si)
        }
    ];
    if (coilType !== "fluid-cooling" && coilType !== "fluid-heating") {
        doc.push({
            name: "Air",
            data: AirPage.airPage(coilType, si)
        });
        doc.push({
            name: "Coeff Interval",
            data: CoeffIntervalPage.coeffIntervalPage()
        });
    }
    doc.push({
        name: coilType !== "fluid-cooling" && coilType !== "fluid-heating"
            ? "Velocity"
            : "Calculation inputs",
        data: VelocityPage.velocityPage(coilType, si)
    });
    return doc;
}
//# sourceMappingURL=workbook.js.map